export const AUTH = 'AUTH'

export const MARKET_STATS_LIST = 'MARKET_STATS_LIST'
export const MARKET_STATS_LIST_ALL = 'MARKET_STATS_LIST_ALL'
